import { IPointsParams, IPointsDetail } from '../interface/student';
import { fetchData } from '@umu/umu-fetch';
import { API } from '../api';
import { defaultPointsDetail } from './defaultData/student';
/*
 * 获取制定小节下学员积分
 */
const getStudentPointsBySession = (param: IPointsParams): Promise<IPointsDetail> => {
    return fetchData(API.GET_STUDENT_POINTS_DETAIL_INFO, param, { silent: true }).then(
        (res: IResponse<IPointsDetail>) => {
            return res.data ? res.data : defaultPointsDetail;
        },
        () => {
            return defaultPointsDetail;
        },
    );
};
const setStudentPointsBySession = (param: IPointsParams) => {
    return fetchData(API.SET_STUDENT_POINTS, param, { silent: true }).then(
        (res: IResponse<{ student_id: number }>) => {
            return {
                isSuccess: !!res.data?.student_id,
                data: res.data,
                errorMsg: res.error_message || '',
            };
        },
        () => {
            return {
                isSuccess: false,
                data: {},
                errorMsg: '',
            };
        },
    );
};
export const studentPointsServer = {
    pointsDetail: getStudentPointsBySession,
    setPointsCount: setStudentPointsBySession,
};
